// extracted by mini-css-extract-plugin
module.exports = {"tabl-comapre":"CompareSection_tabl-comapre__CWY8v"};